<template>
  <div class="template-type">
    <b-tabs class="form-group">
      <h4 class="line">
        {{ getReplyTrans('choose_message_template') }}</h4>

      <b-tabs
        v-model="tabIndex"
        content-class="mt-2"
        justified
      >
        <b-tab
          v-for="(template,ind) in templates"
          :key="'template-tab-' + ind"
          :title="getReplyTrans(((template==='generic')?'cards':template))"
        >
          <component
            :is="'template-'+form.message_type"
            :key="template"
            :ref="template"
            v-bind="$props"
          />
        </b-tab>
      </b-tabs>
    </b-tabs>
  </div>
</template>

<script>
import { BTab, BTabs } from 'bootstrap-vue'
import TextTemplate from './TextTemplate'
import ButtonsTemplate from './ButtonsTemplate'
import GenericTemplate from './CardsTemplate'
import ImageTemplate from './ImageTemplate'

export default {
  name: 'ReplyTypes',
  components: {
    BTab,
    BTabs,
    'template-text': TextTemplate,
    'template-buttons': ButtonsTemplate,
    'template-generic': GenericTemplate,
    'template-image': ImageTemplate,
  },
  props: {
    type: {
      type: String,
      default: 'reply_message',
    },
    tabI: {
      type: Number,
      default: 0,
    },
    isFacebook: {
      type: Boolean,
      default: true,
    },
    isBot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabIndex: 0,
      templates: [
        'text',
        'generic',
        'image',
      ],
      active: 'text',
    }
  },
  computed: {
    isEdit() {
      return this.form?.id
    },
    form() {
      const storeLabel = this.isBot ? 'bot/form' : 'reply/form'
      return this.$store.getters[storeLabel]
    },
  },
  watch: {
    tabIndex() {
      this.changeType()
    },
  },
  mounted() {
    // FB + Instagram both support Messenger button template
    this.templates.splice(1, 0, 'buttons')
    setTimeout(() => { this.tabIndex = this.tabI }, 1000)
  },
  methods: {
    getReplyTrans(string) {
      return this.$t(`reply.form.${string}`)
    },
    changeType() {
      let type = 'text'
      if (this.isFacebook && this.form.include_url) {
        if (![0, 1].includes(this.tabIndex)) {
          this.$notifyError('تضمين رابط المنشور يعمل فقط مع الرد بشكل نص او الرد بشكل ازرار')
          this.tabIndex = 0
        }
      }
      switch (this.tabIndex) {
        case 1: type = 'buttons'; break
        case 2: type = 'generic'; break
        case 3: type = 'image'; break
        default: type = 'text'; break
      }
      const storeLabel = this.isBot ? 'bot/SET_FORM' : 'reply/SET_FORM'
      this.$store.commit(storeLabel, { message_type: type })
    },
  },
}
</script>
